import type { Project } from '@/entities/project';
import request from '@/shared/api/request';

export const updateProject = (
  uuid: string,
  data: {
    name: string;
    description: string;
    color: string;
    is_default: boolean;
    environment: string;
    budget: number;
  },
): Promise<{ project: Project }> =>
  request({
    url: `/projects/${uuid}/`,
    method: 'PUT',
    data,
  });
